<template>
    <div class="xes-handout-filter" id="xes-handout-filter">
        <filterBox :filterInfo="filterInfo" :formData="formData" @change="filterChange" @clear="clearData" :filterOption="filterOptions"></filterBox>
        <handoutList :list="list" :selectType="selectType" @selection="setSelection" :tableOption="tableOptions"></handoutList>
        <div class="xes-handout-filter-bottom">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="formData.perpage"
                :current-page.sync="formData.curpage"
                @current-change="pageChange"
                v-if="total > 0"
            >
            </el-pagination>
            <div class="bottomButtons">
                <slot name="bottomButtons" :data="selection"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { httpRequest } from '../../../src/utils/ajax'
import filterBox from './filter'
import handoutList from './list'
export default {
    name: 'xes-handout-filter',
    props: {
        actions: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        },
        option: {
            type: Object,
            default() {
                return {}
            }
        },
        token: {
            type: String,
            required: true
        },
        selectType: {
            type: String,
            default: 'checkBox'
        },
        activelist: {
            type: Array,
            default: function() {
                return []
            }
        },
        filterOption: {
            type: Object,
            default: function() {
                return {}
            }
        },
        tableOption: {
            type: Object,
            default: function() {
                return {}
            }
        },
        filterData: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            list: [],
            active: 0,
            secret: '',
            loading: false,
            total: 0,
            filterInfo: {
                //筛选项列表
                areas: [],
                freeze: [],
                grade: [],
                plan: [],
                status: [],
                terms: [],
                type: [],
                version: [],
                years: []
            },
            formData: {
                curpage: 1, //当前页码
                perpage: 10, //每页条数
                ids: '', //搜索讲义id
                name: '', //搜索讲义名称
                creator: '', //搜索创建人
                status: '', //状态
                type: '', //类型
                grade: '', //年级
                version: '', //版本
                area: '', //地区
                term: '', //学期
                year: '', //学年
                plan: '', //讲次；多选以"|"隔开、讲次为空对应0
                is_freeze: '', //冻结状态：1为冻结，（默认）0未冻结
                rank_string: '', //知识点ID；以"|"隔开
                environment: '', //1正式数据，2测试数据
                is_underline: '', //是否线下讲义 0：线上讲义 1：线下讲义 （默认）0线上讲义
                order_field: '', //排序字段：可选创建时间create_time 修改时间modify_time 讲次plan_seq
                order_type: '', //字段排序方式 0倒序 1正序，默认倒序
                subject_id: '', //学科
                division_id: '', //学部
                search_mode: '1', //搜索模式
                search_text: '' //搜索内容
            },
            selection: ''
        }
    },
    computed: {
        filterOptions() {
            let option = {
                year: true,
                term: true,
                grade: true,
                version: true,
                area: true,
                plan: true,
                is_freeze: true,
                status: true,
                type: true,
                search: true,
                ...this.filterOption
            }
            return option
        },
        tableOptions() {
            let option = {
                id: true,
                name: true,
                year_name: true,
                term_name: true,
                grade_name: true,
                version_name: true,
                create_real_name: true,
                create_time: true,
                modify_real_name: true,
                modify_time: true,
                plan_name: true,
                area_name: true,
                status_name: true,
                freeze_name: true,
                ...this.tableOption
            }
            return option
        }
    },
    created() {
        // this.getSecret()
        this.initData()
        this.getSearchOptions()
    },
    methods: {
        getSecret() {
            //获取secret
            const isActionNotPass = this.throwError('getSecret')
            if (!isActionNotPass) return
            var option = {
                method: 'POST',
                params: { uuid: this.getCookie('X-Request-Id') },
                action: this.actions.getSecret
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.secret = res.data
                        this.getSearchOptions()
                        this.ajaxSuccess({ ...res, flag: 'getSecret' })
                    } else {
                        this.statusError(res)
                    }
                })
                .catch(err => {
                    this.ajaxError(err)
                })
        },
        getCookie(name) {
            if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(name + '=')
                if (start != -1) {
                    start = start + name.length + 1
                    var end = document.cookie.indexOf(';', start)
                    if (end == -1) {
                        end = document.cookie.length
                    }
                    return unescape(document.cookie.substring(start, end))
                }
            }
            return ''
        },
        throwError(action) {
            // 若无相关地址，抛出错误
            if (!this.actions[action]) {
                throw new Error(`${action}地址为空！`)
            }
            return true
        },
        statusError(data) {
            console.log(data)
            this.$emit('status-error', data)
        },
        ajaxError(data) {
            console.log(data)
            this.$emit('ajax-error', data)
        },
        ajaxSuccess(data) {
            console.log(data)
            this.$emit('ajax-success', data)
        },
        delNull() {
            for (let i in this.formData) {
                if (this.formData[i] === null) {
                    this.formData[i] = ''
                }
            }
        },
        // 筛选项改变
        filterChange() {
            this.formData.curpage = 1
            this.delNull()
            this.getList()
        },
        // 设置筛选项默认数据
        initData() {
            this.formData = { ...this.formData, ...this.filterData }
        },
        // 获取筛选项列表
        getSearchOptions() {
            const isActionNotPass = this.throwError('searchOptions')
            if (!isActionNotPass) return
            this.loading = true
            var option = {
                method: 'POST',
                params: {
                    secret: this.secret,
                    division_id: this.formData.division_id,
                    token: this.token
                },
                action: this.actions.searchOptions
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.filterInfo.areas = res.data.areas
                        this.filterInfo.freeze = res.data.freeze
                        this.filterInfo.grade = res.data.grade
                        this.filterInfo.plan = res.data.plan
                        this.filterInfo.status = res.data.status
                        this.filterInfo.terms = res.data.terms
                        this.filterInfo.type = res.data.type
                        this.filterInfo.version = res.data.version
                        this.filterInfo.years = res.data.years
                        let grades = this.filterInfo.grade.map(el=>{
                            return el.id + ''
                        })
                        if(!grades.includes(this.formData.grade+'')){
                            this.formData.grade = ''
                        }
                        this.getList()
                        this.ajaxSuccess({ ...res, flag: 'searchOptions' })
                    } else {
                        this.statusError(res)
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.ajaxError(err)
                    this.loading = false
                })
        },
        // 获取讲义列表
        getList() {
            const isActionNotPass = this.throwError('handoutList')
            if (!isActionNotPass) return
            this.loading = true
            this.formData.ids = ''
            this.formData.name = ''
            this.formData.creator = ''
            if (this.formData.search_mode == '1') {
                this.formData.ids = this.formData.search_text
            }
            if (this.formData.search_mode == '2') {
                this.formData.name = this.formData.search_text
            }
            if (this.formData.search_mode == '3') {
                this.formData.creator = this.formData.search_text
            }
            var option = {
                method: 'POST',
                params: {
                    secret: this.secret,
                    token: this.token,
                    ...this.formData
                },
                action: this.actions.handoutList
            }
            httpRequest(option)
                .then(res => {
                    if (res.status == 100) {
                        this.list = res.data.lists.map(el=>{
                            if(el.is_freeze == '1'){
                                el.freeze_name = '已冻结'
                            }else{
                                el.freeze_name = '未冻结'
                            }
                            return el
                        })
                        this.total = res.data.total
                        this.ajaxSuccess({ ...res, flag: 'handoutList' })
                    } else {
                        this.statusError(res)
                    }
                    this.loading = false
                })
                .catch(err => {
                    this.ajaxError(err)
                    this.loading = false
                })
        },
        pageChange(val) {
            this.formData.curpage = val
            this.getList()
        },
        clearData() {
            this.formData.curpage = 1 //当前页码
            this.formData.perpage = 10 //每页条数
            this.formData.ids = '' //搜索讲义id
            this.formData.name = '' //搜索讲义名称
            this.formData.creator = '' //搜索创建人
            this.formData.status = '' //状态
            this.formData.type = '' //类型
            this.formData.grade = '' //年级
            this.formData.version = '' //版本
            this.formData.area = '' //地区
            this.formData.term = '' //学期
            this.formData.year = '' //学年
            this.formData.plan = '' //讲次；多选以"|"隔开、讲次为空对应0
            this.formData.is_freeze = '' //冻结状态：1为冻结，（默认）0未冻结
            this.formData.rank_string = '' //知识点ID；以"|"隔开
            this.formData.environment = '' //1正式数据，2测试数据
            this.formData.is_underline = '' //是否线下讲义 0：线上讲义 1：线下讲义 （默认）0线上讲义
            this.formData.order_field = '' //排序字段：可选创建时间create_time 修改时间modify_time 讲次plan_seq
            this.formData.order_type = '' //字段排序方式 0倒序 1正序，默认倒序
            // this.formData.subject_id = '' //学科
            // this.formData.division_id = '' //学部
            this.formData.search_mode = '1' //搜索模式
            this.formData.search_text = '' //搜索内容
            this.getList()
        },
        setSelection(selection) {
            if (this.selectType == 'radio') {
                this.selection = selection[0]
            } else {
                this.selection = selection
            }
        },
        getSelection() {
            let data = this.selection || ''
            if (this.selectType == 'checkBox') {
                data = data || []
            }
            return data
        }
    },
    components: {
        filterBox,
        handoutList
    }
}
</script>



// WEBPACK FOOTER //
// packages/handout-filter/src/index.vue